export const defaultThemeText = {
  calcTitle: 'Оплатить сертификат',
  calcSubtitle: '',
  title: 'Prosto — твоя внутренняя опора',
  subtitle: 'Многие из вас столкнулись с тем, что не могут продлить подписку на приложение в Apple Store и Google Play.',
  subtitleExtra: 'Чтобы вне зависимости от обстоятельств вы имели доступ к Prosto app, вы можете сегодня оплатить сертификат для себя или близкого человека на удобный для вас период, а активировать его позже.',
}